import React from "react";
import "../styles/InfoDocumentos.css";
import { useAuth } from "../context/AuthContext.jsx";
import FileManager from "./FileManager.jsx";
import { PieChart } from 'lucide-react';

const InfoPresupuestos = () => {
  const { isAdmin } = useAuth();
  return (
      <div className="doc-page-container" style={{'--doc-color': '#76448a', '--doc-bg-color': '#f8f6fc'}}>
        <div className="doc-page-card">
          <div className="doc-page-header">
            <div className="doc-page-icon"><PieChart size={48} /></div>
            <h2 className="doc-page-title">Información Presupuestaria</h2>
          </div>
          <p className="doc-page-text">Documentación relativa a la ejecución presupuestaria de la <strong>Comuna de Santo Domingo</strong>.</p>
          <FileManager tableName="presupuesto_files" folderName="presupuesto" bucketName="presupuesto" isAdmin={isAdmin} />
        </div>
      </div>
  );
};
export default InfoPresupuestos;